import { render, staticRenderFns } from "./ViewRegistrationConfirmation.vue?vue&type=template&id=e019b814&scoped=true&"
import script from "./ViewRegistrationConfirmation.vue?vue&type=script&lang=ts&"
export * from "./ViewRegistrationConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./ViewRegistrationConfirmation.vue?vue&type=style&index=0&id=e019b814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e019b814",
  null
  
)

export default component.exports